import React from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import styles from "../src/styles/Callus.module.css"; // مسیر برای استایل‌های مجزا
import { FaPhone, FaEnvelope, FaClock, FaCheckCircle } from "react-icons/fa"; // FaCheckCircle برای اینماد اضافه شد
import enamd from "./images/enamd.png";
export default function Callus() {
  return (
    <>
      <Navbar />
      <div className={styles.callusContainer}>
        <div className={styles.heroSection}>
          <h1>تماس با ما در باتری۱۰۰</h1>
          <p>
            ما اینجا هستیم تا به شما کمک کنیم! می‌توانید از طریق راه‌های ارتباطی
            زیر با ما در تماس باشید. تیم متخصص باتری۱۰۰ آماده پاسخگویی به سوالات
            و ارائه بهترین خدمات به شماست.
          </p>
        </div>

        <div className={styles.contentSection}>
          <div className={styles.contactDetails}>
            <h2>اطلاعات تماس و پشتیبانی</h2>
            <p className={styles.introText}>
              تمامی خدمات فروش و پشتیبانی باتری۱۰۰ به صورت آنلاین و از طریق همین
              سایت انجام می‌شود. ما برای راحتی شما، امکان مشاوره و پاسخگویی به
              سوالات را از طریق تماس تلفنی و ایمیل فراهم کرده‌ایم.
            </p>

            <div className={styles.contactInfo}>
              <a href="tel:+989385912556" className={styles.contactItem}>
                <FaPhone className={styles.contactIcon} />
                <span>شماره تماس: 09385912556</span>
              </a>
              <a
                href="mailto:info@battery100.ir"
                className={styles.contactItem}
              >
                <FaEnvelope className={styles.contactIcon} />
                <span>ایمیل: info@battery100.ir</span>
              </a>
              <div className={styles.contactItem}>
                <FaClock className={styles.contactIcon} />
                <span>ساعات کاری: همه روزه آماده خدمت رسانی به شما هستیم</span>
              </div>
              <div className={styles.contactItem}>
                {" "}
                {/* اشاره به اینماد */}
                <FaCheckCircle className={styles.contactIcon} />
                <span>دارای نماد اعتماد الکترونیکی (اینماد)</span>
              </div>
            </div>

            <p className={styles.serviceNote}>
              هزینه ارسال باتری برای تمامی مناطق تهران رایگان است.
              <br />
              هزینه نصب باتری خودرو در محل، در صورت نیاز مشتری،تنها با مبلغ
              100,000 تومان انجام میشود.
            </p>
          </div>

          <div className={styles.onlineServiceInfo}>
            {" "}
            {/* بخش جدید برای تاکید بر خدمات آنلاین */}
            <h2>خدمات آنلاین و اطمینان خرید</h2>
            <p>
              ما در باتری۱۰۰، متعهد به ارائه بهترین تجربه خرید آنلاین باتری‌های
              خودرو و UPS هستیم. سایت ما با بهره‌گیری از نماد اعتماد الکترونیکی
              (اینماد)، بستری امن و قابل اطمینان را برای شما فراهم کرده است.
              می‌توانید با خیالی آسوده، نیازهای باتری خود را به صورت آنلاین از
              ما تهیه کنید و از پشتیبانی کامل تیم ما بهره‌مند شوید.
            </p>
            {/* اینجا می‌تونی تصویر اینماد رو قرار بدی */}
            <div className={styles.enamadPlaceholder}>
              {/* <img src="/path/to/your/enamad-logo.png" alt="نماد اعتماد الکترونیکی" /> */}
              <a
                referrerpolicy="origin"
                target="_blank"
                href="https://trustseal.enamad.ir/?id=617861&Code=1PbKhdIBc6IuPMlzA5D7R8GRuIu3XipG"
              >
                <img
                  src={enamd}
                  alt="نماد اعتماد الکترونیکی"
                  className={styles.enamad}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
